import { Shell, NavBtn } from "../../components/Shell.tsx";
import { Semaforo, type EstadoSemaforo } from "../../components/Semaforo.tsx";
import { useHashSection } from "../../lib/hashRoute.ts";
import { C, st } from "../../ui/theme.ts";

const SECCIONES = ["captura", "aportantes"] as const;
type Seccion = typeof SECCIONES[number];

const seccion: React.CSSProperties = { display: "flex", flexDirection: "column", gap: 6, marginBottom: "1.25rem" };
const etiqueta: React.CSSProperties = { fontSize: 13, color: C.muted };

/**
 * Plano de VENTAS — fricción mínima. El operador captura al aportante como
 * subproducto de la venta y sólo ve el semáforo (sin scores ni jerga). Toda la
 * maquinaria vive en el plano REC. Aquí va el andamiaje; los formularios reales
 * conectan al backend (cliente_aportante / aportacion) en el build siguiente.
 */
export function VentasApp() {
  const [vista, setVista] = useHashSection<Seccion>("ventas", SECCIONES, "captura");
  const nav = (
    <>
      <NavBtn activo={vista === "captura"} onClick={() => { setVista("captura"); }}>Captura</NavBtn>
      <NavBtn activo={vista === "aportantes"} onClick={() => { setVista("aportantes"); }}>Aportantes</NavBtn>
    </>
  );
  return (
    <Shell titulo="Ventas" nav={nav}>
      {vista === "captura" ? <Captura /> : <Aportantes />}
    </Shell>
  );
}

function Captura() {
  return (
    <div>
      <h2 style={{ ...st.display, marginTop: 0 }}>Onboarding del aportante</h2>
      <p style={etiqueta}>Identificación obligatoria siempre (V Bis). El expediente y el INE se conservan 10 años.</p>

      <div style={seccion}>
        <span style={etiqueta}>Tipo de persona</span>
        <select style={st.input} defaultValue="">
          <option value="" disabled>Selecciona…</option>
          <option value="pf">Persona física</option>
          <option value="pm">Persona moral</option>
          <option value="fideicomiso">Fideicomiso</option>
        </select>
      </div>

      <div style={seccion}>
        <span style={etiqueta}>RFC</span>
        <input style={st.input} placeholder="RFC del aportante" />
      </div>

      <div style={seccion}>
        <span style={etiqueta}>Documento de identidad (INE)</span>
        <input style={st.input} type="file" />
        <span style={{ ...etiqueta, fontSize: 12 }}>El OCR pre-llena; el operador coteja el original. Verificación INE: diligencia reforzada.</span>
      </div>

      <div style={seccion}>
        <span style={etiqueta}>Aportación</span>
        <input style={st.input} placeholder="Monto (sin contribuciones)" />
        <label style={{ ...etiqueta, display: "flex", gap: 6, alignItems: "center" }}>
          <input type="checkbox" /> Es preventa / enganche de un inmueble
        </label>
      </div>

      <div style={{ ...st.tarjeta, marginTop: "1.5rem" }}>
        <span style={etiqueta}>Resultado</span>
        <div style={{ marginTop: 8 }}><Semaforo estado="verde" /></div>
      </div>
    </div>
  );
}

const demo: { nombre: string; estado: EstadoSemaforo }[] = [
  { nombre: "Constructora del Valle SA", estado: "verde" },
  { nombre: "María Fernanda Ruiz", estado: "ambar" },
  { nombre: "Inversiones Norte (efectivo alto)", estado: "rojo" },
  { nombre: "Fideicomiso 4421 (sin clasificar)", estado: "gris" },
];

function Aportantes() {
  return (
    <div>
      <h2 style={{ ...st.display, marginTop: 0 }}>Aportantes</h2>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
        <tbody>
          {demo.map((a) => (
            <tr key={a.nombre} style={{ borderBottom: `1px solid ${C.line}` }}>
              <td style={{ padding: "0.6rem 0" }}>{a.nombre}</td>
              <td style={{ padding: "0.6rem 0", textAlign: "right" }}><Semaforo estado={a.estado} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
